import { Card, Input } from '@/components'

import { CNPJ_MASK, PHONE_MASK } from '@/constants/masks'

import { useSoftlead } from './useSoftlead'

import { VALIDATORS } from '@/constants/validators'

import styles from './Softlead.module.scss'

export const Softlead = ({ control }) => {
  const { onBlurField } = useSoftlead()

  return (
    <>
      <Input
        name="cnpj"
        mode="numeric"
        label="CNPJ da minha empresa"
        placeholder="XX.XXX.XXX/0001-XX"
        control={control}
        mask={CNPJ_MASK}
        rules={VALIDATORS.cnpj}
        onBlur={onBlurField}
      />

      <Input
        name="name"
        label="Nome e sobrenome"
        placeholder="João da Silva"
        control={control}
        rules={VALIDATORS.name}
        onBlur={onBlurField}
      />

      <Input
        name="email"
        mode="email"
        label="Email"
        placeholder="email@example.com"
        control={control}
        rules={VALIDATORS.email}
        onBlur={onBlurField}
      />

      <Input
        name="phone"
        mode="tel"
        label="Telefone"
        placeholder="(XX) 9XXXX-XXXX"
        control={control}
        mask={PHONE_MASK}
        rules={VALIDATORS.phone}
        onBlur={onBlurField}
      />

      <Card size="xs" bgColor="gray" className={styles.softlead__terms}>
        <span>
          Ao continuar você autoriza que os dados fornecidos sejam
          utilizados&nbsp;
        </span>
        <span>
          com a finalidade específica de ser contatado por e-mail,
          telefone,&nbsp;
        </span>
        <span>
          Whatsapp ou SMS, para recebimento de ofertas de produtos e
          serviços&nbsp;
        </span>
        <span>da Equifax BoaVista.&nbsp;</span>
      </Card>
    </>
  )
}
